
import React from "react";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { TutorialSection } from "@/types/tutorial";

interface TutorialCreationSidebarProps {
  sections: TutorialSection[];
  bomItemCount: number;
  expanded: boolean;
  onToggle?: () => void;
}

const TutorialCreationSidebar: React.FC<TutorialCreationSidebarProps> = ({
  sections,
  bomItemCount,
  expanded,
  onToggle
}) => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start',
        inline: 'nearest'
      });
    }
  };

  if (!expanded) {
    return (
      <div className="h-full flex items-start justify-center pt-4">
        {onToggle && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onToggle}
            className="p-2"
          >
            <ChevronRight size={16} />
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center justify-between p-4 border-b">
        <h3 className="font-semibold text-sm">Tutorial Outline</h3>
        {onToggle && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onToggle}
            className="p-2"
          >
            <ChevronLeft size={16} />
          </Button>
        )}
      </div>
      
      <ScrollArea className="flex-1">
        <div className="p-4 space-y-2">
          <Button
            variant="ghost"
            className="w-full justify-start text-sm h-8"
            onClick={() => scrollToSection('basic-info')}
          >
            Basic Information
          </Button>
          
          <Button
            variant="ghost"
            className="w-full justify-start text-sm h-8"
            onClick={() => scrollToSection('bom')}
          >
            Bill of Materials ({bomItemCount})
          </Button>
          
          <Button
            variant="ghost"
            className="w-full justify-start text-sm h-8"
            onClick={() => scrollToSection('sections')}
          >
            Tutorial Sections ({sections.length})
          </Button>
          
          {sections.map((section, index) => (
            <Button
              key={section.id}
              variant="ghost"
              className="w-full justify-start text-xs h-7 pl-6 text-muted-foreground"
              onClick={() => scrollToSection(`section-${section.id}`)}
            >
              {index + 1}. {section.title || 'Untitled Section'} ({section.steps?.length || 0} steps)
            </Button>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};

export default TutorialCreationSidebar;
